<template>
  <div class="login">
    <div class="header">
      <div class="header-name">
        <div>{{ i18nCompetitionName }}</div>
        <div class="register-time">
          <i class="el-icon-time time-icon"></i>
          {{ $t('register.registerTime') }}: {{competitionInfo.registerStartTime}} - {{competitionInfo.registerEndTime}}
        </div>
      </div>
      <div class="header-logo">
        <div class="logo-img" v-if="competitionInfo.logo1"><img :src="define.previewNginxUrl + competitionInfo.logo1"/></div>
        <div class="logo-img" v-if="competitionInfo.logo2"><img :src="define.previewNginxUrl + competitionInfo.logo2"/></div>
        <div class="logo-img" v-if="competitionInfo.logo3"><img :src="define.previewNginxUrl + competitionInfo.logo3"/></div>
        <LangSwitcher />
      </div>
    </div>
    <div class="center">
      <div class="login-form">
        <div class="login-top">{{ $t('register.userRegister') }}</div>
        <div class="login-btn">
          <el-form :model="loginForm" :rules="ruleForm" ref="ruleForm" label="top" class="demo-ruleForm">
            <el-form-item :label="$t('register.account')" prop="account" class="custom-label">
              <el-input v-model="loginForm.account" :placeholder="$t('register.placeholderAccount')" @keyup.enter.native="login('ruleForm')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('register.password')" prop="password" class="custom-label">
              <el-input v-model="loginForm.password" :placeholder="$t('register.placeholderPassword')" show-password @keyup.enter.native="login('ruleForm')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('register.mobilePhone')" prop="mobilePhone" class="custom-label">
              <el-input v-model="loginForm.mobilePhone" :placeholder="$t('register.placeholderMobile')" @keyup.enter.native="login('ruleForm')"></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-button class="button" type="primary" @click="login()" :loading="loginLoading">{{ $t('register.registerAndLogin') }}</el-button>
            </el-form-item>
          </el-form>
          <div><el-button type="text" @click="toLogin()">{{ $t('register.goLogin') }}</el-button></div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
import { login } from "@/api/user";
import md5 from "js-md5";
import {getCompetitionInfo} from "@/api/competition";
import Footer from "@/components/Footer.vue";
import LangSwitcher from "@/components/LangSwitcher.vue";
export default {
  name: 'login',
  components: { Footer, LangSwitcher },
  computed: {
    // 赛事名称中英文
    i18nCompetitionName() {
      return this.$i18n.locale === 'zh-CN' ? this.competitionInfo.nameCh : (this.competitionInfo.nameEn || this.competitionInfo.nameCh);
    },
  },
  data() {
    return {
      loginForm: {
        account: '',
        password: '',
        passwordText: '',
        mobilePhone: ''
      },
      loginLoading: false,
      // 赛事ID
      competitionId: '',
      // 赛事信息
      competitionInfo: {},
      ruleForm: {
        account: [
          { required: true, message: this.$t('register.placeholderAccount'), trigger: "blur" },
        ],
        password: [
          { required: true, message: this.$t('register.placeholderPassword'), trigger: "blur"},
        ],
        mobilePhone: [
          { required: true, message: this.$t('register.placeholderMobile'), trigger: "blur"},
        ],
      }
    };
  },
  created() {
    let id = this.$route.query.id;
    if (!id) {
      this.$router.push({ path: "/index" });
    } else {
      this.competitionId = id;
      this.findCompetitionInfo();
    }
  },
  mounted() { },
  methods: {
    // 进入注册
    toLogin(){
      this.$router.push({ path: "/login?id=" + this.competitionId });
    },
    // 获取赛事信息
    findCompetitionInfo(){
      getCompetitionInfo(this.competitionId).then((res) => {
        this.competitionInfo = res.data;
      });
    },
    // 注册登录
    login() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          let params = {
            account: this.loginForm.account,
            password: md5(this.loginForm.password),
            passwordText: this.loginForm.password,
            mobilePhone: this.loginForm.mobilePhone,
            platform: 2,
            isLogin: 2
          };
          this.loginLoading = true;
          login(params).then((res) => {
            if (res.code === 200) {
              let data = res.data;
              localStorage.setItem("token", data.token);
              this.$router.push({ path: "/home?id=" + this.competitionId });
              this.loginLoading = false;
            } else {
              this.$message.error(res.msg);
              this.loginLoading = false;
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>

.login {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: url('../assets/image/home_bj.jpg') no-repeat;

  .header {
    width: 100%;
    height: 120px;
    background-color: #001c58;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .header-name{
      font-size: 30px;
      color: #FFFFFF;
      font-weight: 600;
      margin-left: 30px;
      line-height: 36px;
      letter-spacing: 2px;
      text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);

      div:first-child {
        position: relative;
        padding-left: 14px;

        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 4px;
          height: 24px;
          background: #409EFF;
          border-radius: 2px;
        }
      }
    }

    .register-time {
      font-size: 18px;
      background: #83b9f7;
      display: inline-flex;
      align-items: center;
      padding: 6px 18px;
      border-radius: 30px;
      font-weight: bold;
      margin-top: 8px;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);

      .time-icon {
        color: #fff;
        margin-right: 8px;
        font-size: 18px;
      }
    }

    .header-logo {
      display: flex;
      align-items: center;

      /deep/ .lang-switcher {
        margin-right: 16px;
      }

      .logo-img{
        margin: 0 10px;

        img {
          border-radius: 50%;
          width: 100px;
          height: 100px;
        }
      }
    }
  }

  .center {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 50px;

    .login-form {
      width: 800px;
      height: 560px;
      background-color: #ffffff;
      border-radius: 16px;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
      padding: 0 35px;
    }

    .login-top {
      text-align: center;
      font-size: 30px;
      font-weight: 600;
      margin-top: 20px;
      padding-bottom: 15px;
      position: relative;
    }

    .login-btn {
      height: 450px;
      width: 400px;
      margin: 10px auto;
      padding: 0 50px;

      .button {
        width: 100%;
        background-color: #1E50AE;
        border-radius: 8px;
        transition: all 0.3s ease;

        &:hover {
          box-shadow: 0 4px 12px rgba(30, 80, 174, 0.4);
        }
      }
    }
  }
}

.custom-label {
  /deep/ .el-form-item__label {
    font-weight: 500;
    color: #333;
  }
}
</style>
